export const CREATE_SJFCOMPANIES = "CREATE_SJFCOMPANIES";   
export const RETRIEVE_SJFCOMPANIES = "RETRIEVE_SJFCOMPANIES";
export const RETRIEVESINGLE_SJFCOMPANIES = "RETRIEVESINGLE_SJFCOMPANIES";
export const UPDATE_SJFCOMPANIES = "UPDATE_SJFCOMPANIES";   
export const DELETE_SJFCOMPANIES = "DELETE_SJFCOMPANIES";   